<template>
  <main-content-layout title="회원현황" img-src="member_status_icon.png">
    <template v-slot:content>
      <v-row class="member-status-content-layout" align="stretch" dense>
        <v-col class="member-status-content" cols="12">
          <span class="member-status-content-title">전체 회원</span>
          <span>
            <strong class="member-count">{{ memberStatusData.cnt }}</strong>명
          </span>
        </v-col>
        <v-col class="member-status-content" cols="12">
          <span class="member-status-content-title">전월 신규</span>
          <span>
            <strong class="member-count">{{ memberStatusData.prevMonth }}</strong>명
          </span>
        </v-col>
        <v-col class="member-status-content" cols="12">
          <span class="member-status-content-title">금월 신규</span>
          <span><strong class="member-count">{{ memberStatusData.currentMonth }}</strong>명
          </span>
        </v-col>
      </v-row>
    </template>
  </main-content-layout>
</template>

<script>
import {mapGetters} from "vuex";
import MainContentLayout from "@/pages/Main/components/layout/MainContentLayout.vue";
import {axiosInstance} from "@/util/AxiosModule";
import _ from "lodash";

export default {
  name: "MemberStatus",
  components: {MainContentLayout},
  data() {
    return {
      memberStatusData: {}
    }
  },
  computed: {
    ...mapGetters("login", {
      memberRole: "memberRole",
      memberId: "memberId"
    }),
    isAdmin() {
      return this.memberRole === "ADMIN";
    },
    isManager() {
      return this.memberRole === "MANAGER";
    }
  },
  mounted() {
    this.getMemberStatus();
  },
  methods: {
    async getMemberStatus() {
      try {
        const { data } = await axiosInstance.get("/private/member/statistics", {
          params: {
            memberId: this.memberId
          }
        });
        if (!_.isEmpty(data)) {
          this.memberStatusData = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.member-status-content-layout {
  width: 100%;
  .member-status-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 10px 0;
    padding: 0 16px;
    background-color: #ffffff;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    font-size: min(4vw, 20px);
    .member-status-content-title {
      font-weight: bold;
    }
    .member-count {
      margin-right: 2px;
    }
  }
}
</style>